<template>
    <v-container fluid text-xs-center style="padding:0px">
    <v-layout row wrap>
      <v-flex xs8 style="padding-right:20px" align-center align-content-center>
    <div style="min-width:300px;width:400px;margin:0 auto;margin-top:15px;height:50px" class="headline">Pay</div>
             <v-text-field
                type="number"
                style="min-width:300px;width:400px;margin:0 auto;height:53px"
                label="Mobile Number"
                v-model="phone"
                solo
          ></v-text-field>
             <v-text-field
                type="number"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                v-model="amount"
                label="Enter Amount"
                solo
          ></v-text-field>
        <div style="width:100%;float:left">
            <v-btn color="primary" style="min-width:300px;width:400px;margin:0 auto;" @click="submit">Submit</v-btn>
        </div>
        </v-flex>
        <v-flex xs4>
            <v-card style="margin-top:15px;">
            <v-list subheader style="padding-bottom:0px">
          <v-subheader>Commisions</v-subheader>
        <v-divider></v-divider>
        <div v-for="(item,i) in commisions" :key="i">
          <v-list-tile @click="">
            <v-list-tile-avatar>
              <img :src="item.img" @error="errorcom">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >{{item.name}}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
               {{ item.offer}}
            </v-list-tile-action>
          </v-list-tile>
        <v-divider></v-divider>

        </div>

        </v-list>
        </v-card>
        </v-flex>
     </v-layout>
<v-dialog
      v-model="dialog"
      width="500"
        persistent
    >
          <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Transfer Confirmation.
        </v-card-title>

        <v-card-text>
        Are you sure want to Transfer Rs {{amount}} to {{message}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="decline"
          >
          Decline
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="pay()"
          >
            Confirm & pay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>

export default {
    data(){
        return{
            commisions:[],
            amount:'',
            phone:'',
            dialog:false,
            message:""
        }
    },
    methods:{
        decline(){
          let vm = this;
          vm.dialog = false
          vm.amount = ""
          vm.phone = ""
        },
        setarray(name,offer,img){
            let array = {name:name,offer:offer,img:img}
            return array;
        },
        showcommisions(){
            let vm = this;
            vm.commisions = [];
            let docs = vm.commisionlist;
            for(let i=0;i<docs.length;i++){
                if(docs[i].ServiceType=="BP"){
                let doc = docs[i];
                let img = docs[i].Circle_Img_Path;
                if(img=="*"){
                    img = require('../assets/logo_single.png')                
                }else{
                    img = vm.$store.getters.src+img               
                }
                vm.commisions.push(vm.setarray(doc.Service,doc.Offer+"%",img));
                }
            }
        },
        errorcom(e){
            e.target.src =require('../assets/discount.svg');
        },
        notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
            })
        },
        submit(){
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            if(vm.phone=="")return vm.notification("error","Mobile Number Required")
            if(vm.phone.length!=10) return vm.notification("error","Valid Phone Number Required")
            if(vm.amount=="")return vm.notification("error","Amount Required")
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'User_MobileNo':vm.phone,
                'Source':'json'
            }
            vm.$parent.dialog = true;
            vm.$store.dispatch("axiospost",{
                    url:"Get_UserName_By_Mobile",
                    data:doc,
            }).then(function (res) {
                    vm.$parent.dialog = false;
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised." || res.data.Message=="Invalid Account."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.message =  res.data.Message;
                       vm.dialog =true;
                    }
                    return vm.notification("error",res.data.Message);
            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error);
                    vm.$parent.dialog = false;
            })

        },
        pay(){
            let vm = this;
            vm.dialog = false;
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'User_MobileNo':vm.phone,
                'Source':'json',
                'TransId':'NA',
                'Amount':vm.amount,
                'TransferTo':vm.phone,
                'Mode':'Load'
                };
            vm.$store.dispatch("axiospost",{
                    url:"Peer_To_Peer",
                    data:doc,
            }).then(function (res) {
                    vm.$parent.dialog = false;
                    vm.$store.dispatch("getbalance");
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised." || res.data.Message=="Invalid Account."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.message =  res.data.Message;
                       vm.dialog = false;
                       vm.phone ="";
                       vm.amount="";
                       return vm.notification("success","Success");
                    }
            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error);
                    vm.$parent.dialog = false;
            })


        }
    },
    computed:{
        commisionlist(){
            return this.$store.getters.commissions;
        },
        user(){
            return this.$store.getters.user
        }
    },
    watch:{
        commisionlist(docs){
            let vm = this;
            vm.showcommisions()
        }
    },
    mounted(){
        let vm = this;
        vm.showcommisions()
    }
}
</script>

<style scoped>
.v-input--radio-group__input{
    width: 400px;
}

.positionbtn{
    min-width:300px;width:400px;margin:0 auto;height:53px
}
</style>
